import React from "react";

const GOLD = "#ebb51b";
const GRAY = "#9a9ca1";

export const SupplierOrdersIcon = ({
  size = 28,
  className = "",
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Clipboard */}
      <rect
        x="13"
        y="10"
        width="38"
        height="45"
        rx="5"
        stroke={GOLD}
        strokeWidth="4"
      />

      {/* Parte superiore clipboard */}
      <rect
        x="23"
        y="6"
        width="18"
        height="9"
        rx="3"
        fill={GOLD}
      />

      {/* Check 1 */}
      <path
        d="M20 25L23 28L28 22"
        stroke={GRAY}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M33 25H44"
        stroke={GRAY}
        strokeWidth="3"
        strokeLinecap="round"
      />

      {/* Check 2 */}
      <path
        d="M20 37L23 40L28 34"
        stroke={GRAY}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M33 37H44"
        stroke={GRAY}
        strokeWidth="3"
        strokeLinecap="round"
      />

      {/* Pacco piccolo */}
      <rect
        x="35"
        y="44"
        width="13"
        height="10"
        rx="2"
        fill={GOLD}
      />

      {/* Nastro pacco */}
      <rect
        x="40"
        y="44"
        width="3"
        height="5"
        fill={GRAY}
      />
    </svg>
  );
};

export default SupplierOrdersIcon;